export default "/static/4785be64a342c424.svg"